module.exports = __webpack_public_path__ + "img/Logo5.9e67961b.png";